import _ from 'lodash'
import StringFormat from '@/utils/StringFormat'
import Constants from '@/utils/Constants'

export default {
  name: 'DataTable',
  components: {},
  props: {
    loading: Boolean,
    headers: Array,
    items: Array,
    totalItems: Number,
    rowsPerPage: Number,
    showMenu: {
      type: Boolean,
      default: false
    },
    menuHeader: Object,
    menuItems: Array,
    menuLabel: String,
    showFooter: {
      type: Boolean,
      default: true
    },
    showFooterAction: {
      type: Boolean,
      default: true
    },
    showSelect: {
      type: Boolean,
      default: true
    },
    selectAll: {
      type: Boolean,
      default: true
    },
    isSmallScreen: {
      type: Boolean,
      default: false
    },
    showFloatingDelete: {
      type: Boolean,
      default: false
    },
    floatingDeleteText: {
      type: String,
      default: '選択を削除'
    }
  },
  data: () => ({
    selected: [],
    menuSelected: [],
    innerPagination: {
      rowsPerPage: 20,
      totalVisible: 8
    },
    isDisable: false,
    analyzeResultMenus: {
      menuItems1: [
        { label: '分析結果', value: '/', kind: 'router', target: 'result' },
        { label: '再実行', value: '/login', kind: 'router', target: 'analyze' },
        { label: '予約', value: '/error', kind: 'router', target: 'reservation' },
        { label: '編集', value: '', kind: 'edit', target: null }
      ],
      menuItems2: [
        { label: '再実行', value: '/login', kind: 'router', target: 'analyze' },
        { label: '予約', value: '/error', kind: 'router', target: 'reservation' },
        { label: '編集', value: '', kind: 'edit', target: null }
      ],
      menuItems3: [
        { label: '分析結果', value: '/', kind: 'router', target: 'result' }
      ],
      menuItems4: []
    },
    analyzeResultActivator: null,
    currentAnalyzeResult: {},
    menuItemsLink: [],
    menuItemsDiv: []
  }),
  watch: {
    innerPagination: {
      handler () {
        if (this.selected.length > 0) {
          this.selected = []
        }
        this.$emit('onPagination', this.innerPagination)
      },
      deep: true
    },
    selected: {
      handler (newVal) {
        this.$emit('on-selection-changed', newVal, this.disableAllSelected)
      },
      deep: true
    },
    items: {
      handler () {
        if (this.selected.length > 0) {
          this.selected = []
        }
        this.$emit('on-selection-changed', this.selected, this.disableAllSelected)
      }
    }
  },
  created () {
    if (this.rowsPerPage !== null) {
      this.innerPagination.rowsPerPage = this.rowsPerPage
    }
    if (this.showMenu) {
      let headerMenu = _.find(this.headers, { type: 'menu' })
      if (_.isEmpty(headerMenu)) {
        this.headers.push(this.menuHeader)
      }
    }
  },
  mounted () {
  },
  filters: {
    formatText (text, length) {
      if (!text) {
        return ''
      }
      if (!length) {
        length = 6
      }
      if (text.length > length) {
        return text.substr(0, length - 1) + '...'
      }
      return text
    },
    formatResult (text, type) {
      if (!text) {
        if (type === 'int') return '0'
        if (type === 'float') return '0.00'
        if (type === 'percent') return '0.00%'
        return
      }
      if (type === 'percent') {
        text = text - 0
        text = StringFormat.nFormat(text * 100, 2, true, 0) + '%'
      } else if (type === 'float') {
        text = text - 0
        text = StringFormat.nFormat(text, 2, true, 0)
      } else if (type === 'int') {
        text = text - 0
        text = StringFormat.nFormat(text, 0, true, 0)
      }
      return text
    },
    tripHtml (text) {
      if (!text) {
        return ''
      }
      return text.replace('<br/>', ' ')
    }
  },
  computed: {
    pages () {
      if (this.innerPagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0
      return Math.ceil(this.totalItems / this.innerPagination.rowsPerPage)
    },
    disableAllSelected () {
      let selfItems = _.filter(this.items, (item) => {
        return !('show_edit' in item) || item.show_edit === 1
      })
      return !selfItems.length || this.selected.length === selfItems.length
    }
  },
  methods: {
    isIEBrowser () {
      /* eslint-disable */
      return /*@cc_on!@*/ false || !!document.documentMode
    },
    processAnalyzeMenu (index) {
      this.currentAnalyzeResult = this.items[index]
      const type = this.decideAnalyzeResultMenuType(this.currentAnalyzeResult)
      if (type === 1) {
        this.menuItemsLink = this.analyzeResultMenus.menuItems1.slice(0, 3)
        this.menuItemsDiv = this.analyzeResultMenus.menuItems1.slice(3)
      } else if (type === 2) {
        this.menuItemsLink = this.analyzeResultMenus.menuItems2.slice(0, 2)
        this.menuItemsDiv = this.analyzeResultMenus.menuItems2.slice(2)
      } else if (type === 3) {
        this.menuItemsLink = this.analyzeResultMenus.menuItems3
        this.menuItemsDiv = []
      } else {
        this.menuItemsLink = this.analyzeResultMenus.menuItems4
        this.menuItemsDiv = []
      }
    },
    clickAnalyzeMenu (index) {
      let el = this.$refs['menuActivator' + index][0]
      if (!el) {
        el = this.$refs['menuActivator' + index]
      }
      this.processAnalyzeMenu(index)
      // ２回目のクリックするとメニューが出れるの一旦対応
      if (el.$el !== this.analyzeResultActivator) {
        this.analyzeResultActivator = el.$el
        this.$nextTick(() => {
          this.analyzeResultActivator.click(index)
        })
      }
    },
    focusAnalyzeMenu (index) {
      let el = this.$refs['menuActivator' + index][0]
      if (!el) {
        el = this.$refs['menuActivator' + index]
      }
      this.processAnalyzeMenu(index)
      if (el.$el !== this.analyzeResultActivator) {
        this.analyzeResultActivator = el.$el
      }
    },
    onDeleteSelected () {
      this.g_openDialog('削除確認', '選択項目を削除します。よろしいですか？', '削除', 'キャンセル', false, (type) => {
        if (type === 'commit') {
          console.log('todo:delete ok', this.selected)
          // this.selected.splice(0)
          this.$emit('onDeleteItems', this.selected)
          this.selected = []
        }
      })
    },
    onAllSelected () {
      this.selected.length = 0
      this.selected = _.filter(this.items, (item) => {
        return !('show_edit' in item) || item.show_edit === 1
      })
      this.isDisable = true
      console.log('onAllSelected', this.selected)
    },
    onAllUnselected () {
      if (this.selected.length > 0) {
        this.selected = []
      }
      this.isDisable = false
      console.log('onAllUnselected', this.selected)
    },
    onSelectedMenuItem (selectObj, menuItem) {
      if (!menuItem) {
        menuItem = this.menuSelected[selectObj.id]
      }
      if (menuItem.kind === 'router') {
        let routerData = {
          data: selectObj,
          menuItem: menuItem
        }
        this.$store.dispatch('routerdata/set', routerData)
      } else {
        this.$emit('onSelectedMenuItem', selectObj, menuItem)
      }
      this.menuSelected = []
    },
    getLink (menuItem) {
      const selectObj = this.currentAnalyzeResult
      if (menuItem.target === 'result') {
        return this.$router.resolve({ path: `/result/${selectObj.id}` }).href
      } else if (menuItem.target === 'analyze') {
        let path = '/analyze/'.concat(selectObj.analyze_target_code)
        let routeTarget = {
          path: path,
          query: {
            history_id: selectObj.id
          }
        }
        return this.$router.resolve(routeTarget).href
      } else if (menuItem.target === 'reservation') {
        let path = '/analyze/'.concat(selectObj.analyze_target_code)
        let routeTarget = {
          path: path,
          query: {
            history_id: selectObj.id,
            is_reservation: 1
          }
        }
        return this.$router.resolve(routeTarget).href
      }
    },
    showButton (type, item) {
      if (type === 'edit') {
        return !('show_edit' in item) || item.show_edit === 1
      } else if (type === 'copy') {
        return true
      } else if (type === 'download') {
        return !('show_download' in item) || item.show_download === 1
      } else if (type === 'download_mask_code') {
        return item.show_download_mask_code === 1
      } else if (type === 'download_code') {
        return item.show_download_code === 1
      }
    },
    onClickButton (type, item) {
      if (type === 'edit') {
        this.$emit('onEdit', item)
      } else if (type === 'copy') {
        delete item['id']
        this.$emit('onCopy', item)
      } else if (type === 'download') {
        this.$emit('onDownload', item)
      } else if (type === 'download_mask_code') {
        item.type = 1
        this.$emit('onDownload', item)
      } else if (type === 'download_code') {
        item.type = 2
        this.$emit('onDownload', item)
      }
    },
    onClickItem (item) {
      this.$emit('onClickItem', item)
    },
    decideMenu (status, userId) {
      if (this.$route.name === 'PageHistoryList') {
        // 分析履歴一覧画面の場合、メニュー項目を決定する
        if (Constants.getUser('id') === userId) {
          if (status === 2) {
            return this.analyzeResultMenus.menuItems1
          } else {
            return this.analyzeResultMenus.menuItems2
          }
        } else {
          if (status === 2) {
            return this.analyzeResultMenus.menuItems3
          } else {
            return this.analyzeResultMenus.menuItems4
          }
        }
      } else {
        return this.menuItems
      }
    },
    decideAnalyzeResultMenuType (currentAnalyzeResult) {
      if (this.$route.name === 'PageHistoryList' && currentAnalyzeResult) {
        const status = currentAnalyzeResult.status_
        const userId = currentAnalyzeResult.user_id
        // 分析履歴一覧画面の場合、メニュー項目を決定する
        if (Constants.getUser('id') === userId) {
          if (status === 2) {
            return 1
          } else {
            return 2
          }
        } else {
          if (status === 2) {
            return 3
          } else {
            return 4
          }
        }
      }
      return 4
    }
  }
}
